import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import ScrollToTop from './components/ScrollToTop';
import ExternalLinkHandler from './components/ExternalLinkHandler';
import EventTracker from './components/EventTracker';
import useTrackingData from './hooks/useTrackingData';

const HomePage = () => {
  return (
    <HeroSection onCtaClick={() => {}} />
  );
};


function App() {
  // Initialize tracking data on app load
  useTrackingData();

  return (
    <Router>
      <EventTracker />
      <ExternalLinkHandler />
      <ScrollToTop />
      <div className="min-h-screen bg-[#fefbf4] text-[#4d3e3e]">
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;